export const environment = {
  production: true,
  apiUrl: 'https://showcase.assinadorserpro.estaleiro.serpro.gov.br/assinador/api/',
  minimalistUrl: 'https://www.assinadorserpro.estaleiro.serpro.gov.br/minimalista/tutorial/'
};



// WEBPACK FOOTER //
// /home/fabiano/git/assinador-showcase/frontend/src/environments/environment.ts